// Display labels of the Arbeitszeitnachweis. Keys are English sentences of the "dashboard"
// namespace; call with the component's `t`.

export const TYPE_META = {
  WORK: { label: "Work", color: "green" },
  TRAVEL: { label: "Travel", color: "blue" },
  BREAK: { label: "Break", color: "orange" },
  END: { label: "End / off", color: "default" }
};

export const STATUS_META = {
  NOT_STARTED: { label: "Not Started", color: "default" },
  CHECKED_IN: { label: "Working", color: "green" },
  ON_BREAK: { label: "On Break", color: "orange" },
  TRAVELLING: { label: "Travelling", color: "blue" },
  CHECKED_OUT: { label: "Finished", color: "geekblue" }
};

const hours = minutes => `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, "0")}`;

export const warningText = (t, warning) => {
  const code = warning?.code || warning;
  switch (code) {
    case "BREAK_TOO_SHORT":
      return warning?.required
        ? t("Breaks too short: {{actual}} of {{required}} minutes (§ 4 ArbZG)", {
            actual: warning.actual,
            required: warning.required
          })
        : t("Breaks too short (§ 4 ArbZG)");
    case "WORK_WITHOUT_BREAK":
      return t("More than 6 hours in a row without a break (§ 4 ArbZG)");
    case "MAX_DAILY_EXCEEDED":
      return t("More than 10 working hours (§ 3 ArbZG)");
    case "REST_TOO_SHORT":
      return warning?.minutes !== undefined
        ? t("Only {{hours}} h rest since the previous day, 11 h required (§ 5 ArbZG)", {
            hours: hours(warning.minutes)
          })
        : t("Less than 11 hours rest since the previous day (§ 5 ArbZG)");
    default:
      return code;
  }
};

export const errorText = (t, code) =>
  ({
    TIME_MISSING: t("Enter a time"),
    SAME_TIME: t("Same time as the point before"),
    END_MISSING: t("Add the end of the day"),
    INVALID_TYPE: t("Invalid entry"),
    INVALID_TIME: t("Invalid entry"),
    END_BEFORE_START: t("Ends before it starts"),
    OVERLAP: t("Overlaps the entry before"),
    OPEN_NOT_LAST: t("Only the last entry can still be running"),
    IN_FUTURE: t("Times in the future cannot be recorded"),
    OUTSIDE_DAY: t("The first time must be on this day"),
    SPAN_TOO_LONG: t("A day cannot be longer than 24 hours"),
    OVERLAPS_PREVIOUS_DAY: t("Overlaps the times of the previous day"),
    OVERLAPS_NEXT_DAY: t("Overlaps the times of the next day")
  }[code] || code);
